import { Component, OnInit, Inject, HostBinding, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalibrationSetTableFieldAttributeService } from 'src/app/core/services';

import { AttributeType } from 'src/shared/enums';
import { UntypedFormBuilder } from '@angular/forms';

import * as _ from 'lodash';
import { AttributesPopupComponent } from './attributes-popup.component';
import { forkJoin } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { CalibrationSetTableFieldAttribute } from 'src/app/models/calibrations/calibration-set-table-field-attribute.model';
import { IAttributePopupParams } from 'src/app/interfaces/attribute-popup-params.interface';

@Component({
    standalone: false,
    selector: 'calibration-set-table-field-attributes-popup',
    templateUrl: './attributes-popup.component.html',
    styleUrls: ['./attributes-popup.component.scss'],
    encapsulation: ViewEncapsulation.None

})
export class CalibrationSetTableFieldAttributesPopupComponent extends AttributesPopupComponent implements OnInit {
    @HostBinding('class')
    readonly hostClass = 'attributes-popup';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IAttributePopupParams,
        protected readonly attributeService: CalibrationSetTableFieldAttributeService,
        protected readonly formBuilder: UntypedFormBuilder,
        public dialogRef: MatDialogRef<CalibrationSetTableFieldAttributesPopupComponent>
    ) {
        super(data, formBuilder);
    }

    get parentId() {
        return _.get(this.data, 'parameters.ParentId', 0);
    }

    get parentType() {
        return _.get(this.data, 'parameters.ParentType', 0);
    }

    get tableFieldId() {
        return _.get(this.data, 'parameters.TableFieldId', 0);
    }

    get tableFieldOption() {
        return _.get(this.data, 'parameters.TableFieldOption', 0);
    }

    ngOnInit() {
        super.ngOnInit();
        this.attributeService
            .getAttributesForCalibrationSetTableField(
                this.parentId,
                this.parentType,
                this.tableFieldId,
                this.tableFieldOption
            )
            .subscribe(attributes => this.initAttributes(attributes));
    }

    addNewLink() {
        if (this.linkForm.invalid) {
            return;
        }

        const newLink = new CalibrationSetTableFieldAttribute({
            ParentId: this.parentId,
            ParentType: this.parentType,
            TableFieldId: this.tableFieldId,
            TableFieldOption: this.tableFieldOption,
            AttributeType: AttributeType.LINK,
            AttributeValue: this.linkForm.value.linkValue,
            Description: this.linkForm.value.linkDescription
        });

        super.addNewLink(newLink);
    }

    async save() {
        await super.save();

        const queries = this.getAttributeOperationsObservables();

        forkJoin(queries).subscribe();
        this.dialogRef.close();
    }

    initDefaultAssumption() {
        if (!this.assumptionsValue.length) {
            this.setAssumptions(
                this.assumptionsValue.concat(
                new CalibrationSetTableFieldAttribute({
                    ParentId: this.parentId,
                    ParentType: this.parentType,
                    TableFieldId: this.tableFieldId,
                    TableFieldOption: this.tableFieldOption,
                    AttributeType: AttributeType.ASSUMPTION,
                    AttributeValue: '',
                    IsEnabled: false
                })
                )
            );
        }
    }

    initDefaultComment() {
        if (!this.commentsValue.length) {
            this.setComments(
                this.commentsValue.concat(
                new CalibrationSetTableFieldAttribute({
                    ParentId: this.parentId,
                    ParentType: this.parentType,
                    TableFieldId: this.tableFieldId,
                    TableFieldOption: this.tableFieldOption,
                    AttributeType: AttributeType.COMMENT,
                    AttributeValue: ''
                })
                )
            );
        }
    }
}
